"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStat = exports.Stat = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var Stat = /*#__PURE__*/function () {
  function Stat() {
    (0, _classCallCheck2["default"])(this, Stat);
    (0, _defineProperty2["default"])(this, "begins", void 0);
    (0, _defineProperty2["default"])(this, "data", void 0);
    this.begins = new Map();
    this.data = new Map();
  }

  (0, _createClass2["default"])(Stat, [{
    key: "time",
    value: function time() {
      if (window.performance && window.performance.now) {
        return window.performance.now();
      }

      return Date.now();
    }
  }, {
    key: "begin",
    value: function begin(method, props, contextId) {
      this.begins.set(this.slug(method, props, contextId), this.time());
    }
  }, {
    key: "end",
    value: function end(method, props, contextId, success) {
      var slug = this.slug(method, props, contextId);
      var end = this.time();
      var start = this.begins.get(slug);

      if (!start) {
        return;
      }

      this.begins["delete"](slug);
      var duration = end - start;

      var _slug$split = slug.split('_'),
          _slug$split2 = (0, _slicedToArray2["default"])(_slug$split, 1),
          statName = _slug$split2[0];

      if (this.begins.size > 100 || this.data.size > 100) {
        this.flush();
      }

      this.record(statName, duration);

      if (success) {
        this.record("".concat(statName, "_success"), duration);
      } else {
        this.record("".concat(statName, "_failed"), duration);
      }
    }
    /**
     * VKWebAppCallAPIMethod_<randomId>
     */

  }, {
    key: "slug",
    value: function slug(method, props, contextId) {
      if (method === 'VKWebAppCallAPIMethod' && props) {
        return "".concat(props.method || method, "_").concat(contextId || '');
      }

      return "".concat(method, "_").concat(contextId || '');
    }
  }, {
    key: "record",
    value: function record(statName, duration) {
      var prev = this.data.get(statName) || {
        max: 0,
        avg: 0,
        count: 0,
        sum: 0
      };
      prev.count++;
      prev.sum += duration;
      prev.avg = prev.sum / prev.count;
      prev.max = Math.max(prev.max, duration);
      this.data.set(statName, prev);
    }
  }, {
    key: "flush",
    value: function flush() {
      this.data.clear();
      this.begins.clear();
    }
  }, {
    key: "toPlainObject",
    value: function toPlainObject() {
      var data = {};
      this.data.forEach(function (value, key) {
        data[key] = value;
      });
      return data;
    }
  }]);
  return Stat;
}();

exports.Stat = Stat;
var defaultStat = new Stat();
exports.defaultStat = defaultStat;